"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAliasApi = exports.AdminAliasApiFactory = exports.AdminAliasApiFp = exports.AdminAliasApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AdminAliasApi - axios parameter creator
 * @export
 */
exports.AdminAliasApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Edit admin alias
         * @param {string} [tenantId] tenantId
         * @param {string} [name]
         * @param {string} [surname]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdminAlias: (tenantId, name, surname, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/alias/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (surname !== undefined) {
                localVarFormParams.append('surname', surname);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get admin alias
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminAlias: (tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/alias/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminAliasApi - functional programming interface
 * @export
 */
exports.AdminAliasApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdminAliasApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Edit admin alias
         * @param {string} [tenantId] tenantId
         * @param {string} [name]
         * @param {string} [surname]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdminAlias(tenantId, name, surname, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editAdminAlias(tenantId, name, surname, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get admin alias
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminAlias(tenantId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdminAlias(tenantId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminAliasApi - factory interface
 * @export
 */
exports.AdminAliasApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdminAliasApiFp(configuration);
    return {
        /**
         *
         * @summary Edit admin alias
         * @param {string} [tenantId] tenantId
         * @param {string} [name]
         * @param {string} [surname]
         * @param {any} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdminAlias(tenantId, name, surname, file, options) {
            return localVarFp.editAdminAlias(tenantId, name, surname, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get admin alias
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminAlias(tenantId, options) {
            return localVarFp.getAdminAlias(tenantId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminAliasApi - object-oriented interface
 * @export
 * @class AdminAliasApi
 * @extends {BaseAPI}
 */
class AdminAliasApi extends base_1.BaseAPI {
    /**
     *
     * @summary Edit admin alias
     * @param {string} [tenantId] tenantId
     * @param {string} [name]
     * @param {string} [surname]
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAliasApi
     */
    editAdminAlias(tenantId, name, surname, file, options) {
        return exports.AdminAliasApiFp(this.configuration).editAdminAlias(tenantId, name, surname, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get admin alias
     * @param {string} [tenantId] tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAliasApi
     */
    getAdminAlias(tenantId, options) {
        return exports.AdminAliasApiFp(this.configuration).getAdminAlias(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminAliasApi = AdminAliasApi;
